export const AUTH_TOKEN_EXPIRATION_TIME = 2 * 7 * 24 * 60;
export const REFRESH_TOKEN_EXPIRATION_TIME = 4 * 7 * 24 * 60;
